<template>
    <article class="card">
        <header class="card-header">
            <p class="title">
                {{ transChoice('app.contact', 2).titleCase() }}
            </p>

            <a
                v-if="canCreateContacts && ! preventInteraction"
                @click="newContact()"
                class="card-header-icon"
            >Add</a>
        </header>

        <div class="panel-block search">
            <p class="control has-icons-left">
                <input
                    class="input"
                    type="text"
                    :placeholder="transChoice('app.contact.search', 2).titleCase()"
                    v-model="searchFilter"
                >
                <span class="icon is-left">
                    <i class="fa fa-search"></i>
                </span>
            </p>
        </div>

        <div
            v-if="loading"
            class="content-holder nopad"
        >
            <div
                class="centered loader is-medium"
            ></div>
        </div>

        <div
            v-else
            class="content-holder nopad"
        >
            <div v-if="! isEmpty">
                <span
                    v-for="contact in filteredContacts"
                    :key="contact.id"
                    class="panel-block is-medium"
                >
                    <a
                        :href="route('contacts.show', {contact: contact.id})"
                    >
                        <img
                            style="display: inline-block;"
                            class="thumbnail"
                            :src="contact.small_avatar"
                        >

                        <div style="display: inline-block;vertical-align: top;">
                            <div>
                                <b v-if="contact.primary">{{ contact.first_name }} {{ contact.last_name }}  <small>(Primary)</small></b>
                                <span v-else>{{ contact.first_name }} {{ contact.last_name }}</span>

                            </div>
                            <div class="no-link"><i>{{ contact.title }}</i></div>
                        </div>
                    </a>
                    <span class="is-pulled-right" v-if="canCreateContacts & !preventInteraction">
                        <a @click="editContact(contact)" class="tag is-light">Edit</a>
                    </span>
                </span>
            </div>
            <div class="notification" v-else>
                <p>{{ trans('app.contact.none') }}</p>
            </div>
        </div>
    </article>
</template>

<script>
export default {
    props: {
        canCreateContacts: {
            type: Boolean,
            default: false,
        },

        preventInteraction: {
            type: Boolean,
            default: false,
        },

        contactableType: {
            type: String,
            required: true,
        },

        contactableId: {
            type: Number,
            required: true,
        },
    },

    data () {
        return {
            searchFilter: '',
            contacts: [],
            loading: false,
        };
    },

    listeners: {
        'contacts-updated' () {
            this.fetchList();
        },
    },

    computed: {
        actionRoute () {
            return this.route(
                'contacts.index',
                {
                    contactable_type: this.contactableType,
                    contactable_id: this.contactableId,
                }
            );
        },

        isEmpty () {
            return _.isEmpty(this.contacts);
        },

        filteredContacts () {
            return this.contacts.filter(contact => {
                let name = String(`${contact.first_name} ${contact.last_name}`);

                return name.toLowerCase().indexOf(this.searchFilter.toLowerCase()) > -1;
            });
        },
    },

    methods: {
        isLogoEmpty (logo) {
            return _.isEmpty(logo);
        },

        newContact () {
            OSPEvent.$emit('open-contact-add-modal', this.contactableType, this.contactableId);
        },

        editContact (contact) {
            OSPEvent.$emit('open-contact-edit-modal', contact);
        },

        async fetchList () {
            try {
                this.loading = true;
                let {data} = await axios.get(this.actionRoute);

                this.contacts = data.contacts;
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
    },

    created () {
        this.fetchList();
    },
};
</script>

<style>
.panel-block .thumbnail {
  width: 3em;
}
</style>
